// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"nZ-z","displaySixCardTiles":"oZ-z"};